import * as React from 'react'
import { Title as DefaultTitle } from 'cc-ui-components'
import { convertContentfulImage } from '../DynamicAssembly'

export const Title: React.SFC<any> = ({ icon, ...rest }) => {
  return <DefaultTitle {...rest} icon={convertContentfulImage(icon)} />
}
